import * as s from "../../VideoShareStyled";
import { Text, ValidateWord } from "components/atoms/text/Text";
import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import TextArea from "components/atoms/input/TextArea";
import { VideoShareUserPost } from "api/interfaces/videoshareInterface.interface";
import EmailSelectComponent from "components/atoms/select/email";
import PrimaryButton from "components/atoms/buttons/PrimaryButton";
import { forwardRef } from "react";
import ToggleComponent from "components/atoms/toggle/Toggle";
import * as mediaQuery from "components/MediaQuery";
import CLOSE_ICON from "assets/icons/sidenav/x.svg";
import InputDate from "components/atoms/calendar/InputDate";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { Option } from "utils/options";

type Props = {
  small?: boolean;
  index: number;
  state: VideoShareUserPost;
  isExpired: boolean;
  onChangeModal: (type: string, value: boolean) => void;
  onChangeValue: (e: any) => void;
  onChangeDateValue: (date: string) => void;
  onAddUser: () => void;
  onSelectUser: (user: Option[]) => void;
  today: Date;
  //validateShareDate: Date[];
  isShare: boolean;
  onChangeSharing: (checked: boolean) => void;
  validateMsg: ValidateMsg;
};

const AddVSPresenter = forwardRef<HTMLDivElement, Props>(
  (
    {
      small,
      index,
      state,
      isExpired,
      onChangeModal,
      onChangeValue,
      onChangeDateValue,
      onAddUser,
      onSelectUser,
      //validateShareDate,
      today,
      isShare,
      onChangeSharing,
      validateMsg,
    }: Props,
    ref
  ): JSX.Element => {
    return small ? (
      <s.ShareBubble index={index}>
        <mediaQuery.Mobile>
          <div
            className="close-button-add"
            onClick={() => onChangeModal("add", false)}
            data-testid={`videoshare-add-close-button-${index}`}
          >
            <img alt="close button" src={CLOSE_ICON} />
          </div>
        </mediaQuery.Mobile>
        <s.ShareTitle>
          <Text bold fontSize={18}>
            Sharing
          </Text>
          <ToggleComponent
            onChange={onChangeSharing}
            isToggled={isShare}
            dataTestId="videoshare-add-sharing-toggle"
          />
        </s.ShareTitle>
        {isShare && (
          <s.ShareInner>
            <s.EmailSelectContainer>
              <EmailSelectComponent
                value={state.user.map((user) => user.email)}
                onChange={(_, option) => {
                  onSelectUser(option);
                }}
                //placeholder="Select User or Enter Email Address"
                isVs

                // isSelectedArr={state.user}
              />
            </s.EmailSelectContainer>
            <s.AddCheck>
              <label>
                <input
                  type="checkbox"
                  name="canDownload"
                  checked={state.canDownload}
                  onChange={onChangeValue}
                  data-testid="videoshare-add-can-download"
                />{" "}
                <Text fontSize={14}>Allow Download</Text>
              </label>
            </s.AddCheck>
            <s.AddCheck>
              <label>
                <input
                  name="isExpired"
                  type="checkbox"
                  checked={isExpired}
                  onChange={onChangeValue}
                  data-testid="videoshare-add-is-expired"
                />{" "}
                <Text fontSize={14}>Expiration</Text>
              </label>
              <p className="date-select">
                <InputDate
                  disabled={!isExpired}
                  value={state.expires}
                  endOfDay={true}
                  onChange={(date) => onChangeDateValue(date as string)}
                  minDate={today}
                  // tileDisabled={({ date, view }) =>
                  //   view === "month" &&
                  //   !validateShareDate.some(
                  //     (validDate) =>
                  //       date.getFullYear() === validDate.getFullYear() &&
                  //       date.getMonth() === validDate.getMonth() &&
                  //       date.getDate() === validDate.getDate()
                  //   )
                  // }
                />
              </p>
            </s.AddCheck>
            <s.SendWrapper>
              <PrimaryButton
                buttonType="cancel"
                label="Send"
                onClickBtn={onAddUser}
                data-testid="videoshare-add-primary-button-send"
              />
            </s.SendWrapper>
          </s.ShareInner>
        )}
      </s.ShareBubble>
    ) : (
      <SmallPopupTemplate
        title="Share Video Clip"
        subTitle="Share this video with one or more recipients."
        onClick={onAddUser}
        onModal={() => onChangeModal("add", false)}
        confirmLabel="Send"
        ref={ref}
        className="full-width"
        data-testid="videoshare-add-small-popup-template-add-user"
      >
        <s.EmailSelectContainer>
          <EmailSelectComponent
            value={state.user.map((user) => user.email)}
            //placeholder="Select User or Enter Email Address"
            onChange={(_, option) => {
              onSelectUser(option);
            }}
            isVs
            // isSelectedArr={state.user}
          />
        </s.EmailSelectContainer>

        <ModalInput label="Message (Optional)">
          <TextArea
            name="message"
            value={state.message}
            onChange={onChangeValue}
            placeholder="Please enter a message."
            data-testid="videoshare-add-message"
          />
        </ModalInput>
        <ModalInput
          label={
            <label>
              <input
                name="isExpired"
                type="checkbox"
                checked={isExpired}
                onChange={onChangeValue}
                data-testid="videoshare-add-is-expired-expiration"
              />{" "}
              Expiration
            </label>
          }
        >
          <InputDate
            disabled={!isExpired}
            value={state.expires}
            onChange={(date) => onChangeDateValue(date as string)}
            minDate={today}
          />
        </ModalInput>
        <ModalInput
          label={
            <label>
              <input
                type="checkbox"
                name="canDownload"
                checked={state.canDownload}
                onChange={onChangeValue}
                data-testid="videoshare-add-can-download-download"
              />{" "}
              Allow Download
            </label>
          }
        />

        {validateMsg.emptyUser !== "" && (
          <ValidateWord data-testid="videoshare-add-validate-email">
            {validateMsg.emptyUser}
          </ValidateWord>
        )}

        {validateMsg.invalidEmail !== "" && (
          <ValidateWord data-testid="videoshare-add-validate-email-invalid">
            {validateMsg.invalidEmail}
          </ValidateWord>
        )}
      </SmallPopupTemplate>
    );
  }
);

export default AddVSPresenter;
